import React from 'react';
import './Architecture.css';

const Architecture = () => {
  return (
    <section className="architecture" id="architecture">
      <div className="container">
        <h2 className="section-title">Innowacyjna architektura systemu</h2>
        <p className="section-subtitle">
          MINERVA łączy trzy kluczowe warstwy w spójną, skalowalną infrastrukturę zapewniającą
          niezawodność, wydajność i bezpieczeństwo
        </p>
        
        <div className="arch-visualization">
          <div className="arch-layers">
            <div className="arch-layer layer-central">
              <div className="layer-content">
                <div className="layer-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
                    <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
                    <line x1="6" y1="6" x2="6.01" y2="6"></line>
                    <line x1="6" y1="18" x2="6.01" y2="18"></line>
                  </svg>
                </div>
                <div className="layer-details">
                  <h3>Warstwa centralna</h3>
                  <p>Vertical Agent z zaawansowaną analityką koordynujący pracę całego systemu</p>
                  <ul className="layer-features">
                    <li>Centralne zarządzanie wszystkimi procesami</li>
                    <li>Zaawansowana analityka danych</li>
                    <li>Integracja z systemami ERP</li>
                  </ul>
                </div>
              </div>
              <div className="layer-connector central-to-comm"></div>
            </div>
            
            <div className="arch-layer layer-communication">
              <div className="layer-content">
                <div className="layer-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <polyline points="19 12 12 19 5 12"></polyline>
                  </svg>
                </div>
                <div className="layer-details">
                  <h3>Warstwa komunikacji</h3>
                  <p>MCP (Model Context Protocol) zapewniający standaryzację i bezpieczeństwo</p>
                  <ul className="layer-features">
                    <li>Szyfrowana wymiana danych</li>
                    <li>Standaryzacja formatów komunikacyjnych</li>
                    <li>Inteligentne routowanie priorytetowych informacji</li>
                  </ul>
                </div>
              </div>
              <div className="layer-connector comm-to-edge"></div>
            </div>
            
            <div className="arch-layer layer-edge">
              <div className="layer-content">
                <div className="layer-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                  </svg>
                </div>
                <div className="layer-details">
                  <h3>Warstwa brzegowa</h3>
                  <p>Urządzenia Jetson Nano z przetwarzaniem danych i komunikacją z PLC</p>
                  <ul className="layer-features">
                    <li>Lokalne podejmowanie decyzji</li>
                    <li>Bezpośrednia komunikacja z urządzeniami PLC</li>
                    <li>Działanie nawet przy utracie łączności z centrum</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="floating-elements">
            <div className="floating-element elem-1"></div>
            <div className="floating-element elem-2"></div>
            <div className="floating-element elem-3"></div>
            <div className="floating-element elem-4"></div>
          </div>
        </div>
        
        <div className="arch-benefits">
          <div className="benefit-card">
            <div className="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                <line x1="6" y1="1" x2="6" y2="4"></line>
                <line x1="10" y1="1" x2="10" y2="4"></line>
                <line x1="14" y1="1" x2="14" y2="4"></line>
              </svg>
            </div>
            <h4>Odporność na awarie</h4>
            <p>Zdecentralizowana architektura zapewnia 99.9% dostępności systemu</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
              </svg>
            </div>
            <h4>Błyskawiczne działanie</h4>
            <p>Przetwarzanie danych na brzegu sieci skraca czas reakcji o 75%</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            </div>
            <h4>Wzmocnione bezpieczeństwo</h4>
            <p>Wielowarstwowa ochrona z szyfrowaniem end-to-end dla wszystkich danych</p>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
            </div>
            <h4>Łatwa skalowalność</h4>
            <p>Modułowa struktura umożliwiająca rozbudowę systemu bez przestojów</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Architecture;